import {context} from '../constants/context';
import {halClient} from '../hal';
import {BBModel} from '../bb_model';

const purchase = {

    doPurchaseAPIAction(action, url, params, resolve, reject) {
        halClient[action](url, params)
            .then((purchase) => {
                this.buildPurchaseTotalModels(purchase, resolve, reject);
            })
            .catch(err => reject(err));
    },

    buildPurchaseTotalModels(purchase, resolve, reject) {
        const purchaseTotalModel = new BBModel.Purchase.Total(purchase);
        purchaseTotalModel.getPurchaseData()
            .then(purchaseTotal => resolve(purchaseTotal))
            .catch(err => reject(err));
    },

    query(params) {
        return new Promise((resolve, reject) => {
            const { include_cancelled = false } = params;
            const uri = `${params.url_root}/api/${context.apiVersion}/purchases/${params.purchase_id}?include_cancelled=${include_cancelled}`;
            this.doPurchaseAPIAction('$get', uri, params, resolve, reject);
        });
    },

    bookingRefQuery(params) {
        return new Promise((resolve, reject) => {
            const uri = `${params.url_root}/api/${context.apiVersion}/purchases/booking_ref/${booking_ref}`;
            this.doPurchaseAPIAction('$get', uri, params, resolve, reject);
        });
    },

    update(params) {
        let booking;
        return new Promise((resolve, reject) => {
            const data = {};

            if (!params.purchase) {
                reject('No purchase present');
                return;
            }

            if (params.bookings) {
                const bookingData = [];
                for (booking of Array.from(params.bookings)) {
                    bookingData.push(booking.getPostData());
                }
                data.bookings = bookingData;
            }

            if (params.move_reason) {
                for (booking of Array.from(data.bookings)) {
                    booking.move_reason = params.move_reason;
                }
            }

            params.purchase.$put('self', {}, data)
                .then(purchase => this.buildPurchaseTotalModels(purchase, resolve, reject))
                .catch(err => reject(err));

        });
    },

    bookWaitlistItem(params) {
        return new Promise((resolve, reject) => {
            const data = {
                booking_id: params.booking.id
            };

            if (!params.purchase && !params.purchase_id) {
                reject('No purchase or purchase_id present');
            }

            if (params.purchase) {
                params.purchase.$put('book_waitlist_item', {}, data)
                    .then(purchase => this.buildPurchaseTotalModels(purchase, resolve, reject))
                    .catch(err => reject(err));

            } else if (params.purchase_id && params.url_root) {
                const uri = `${params.url_root}/api/${context.apiVersion}/purchases/${params.purchase_id}/book_waitlist_item`;
                this.doPurchaseAPIAction('$put', uri, params, resolve, reject);
            }

        });
    },

    updateItem(params) {
        return new Promise((resolve, reject) => {
            const { include_cancelled = false,  } = params;
            const uri = `${params.api_url}/api/${context.apiVersion}/purchases/${params.long_id}/bookings/${params.purchase_item_id}?include_cancelled=${include_cancelled}`;
            this.doPurchaseAPIAction('$put', uri, params, resolve, reject);
        });
    },

    deleteItem(params) {
        return new Promise((resolve, reject) => {
            const { include_cancelled = false } = params;
            const uri = `${params.api_url}/api/${context.apiVersion}/purchases/${params.long_id}/bookings/${params.purchase_item_id}?include_cancelled=${include_cancelled}`;
            this.doPurchaseAPIAction('$del', uri, params, resolve, reject);
        });
    },

    delete(params) {
        return new Promise((resolve, reject) => {
            const { include_cancelled = false } = params;
            const uri = `${params.api_url}/api/${context.apiVersion}/purchases/${params.long_id}?include_cancelled=${include_cancelled}`;
            this.doPurchaseAPIAction('$del', uri, params, resolve, reject);
        });
    }
};

export {
    purchase
};
